import { NextPage } from 'next'
import Head from 'next/head'
import Page from '@components/page'
import ContactForm from '@components/undock/forms/contact'
import Module, { ModuleContainer } from '@components/undock/modules'
import ContactModule from '@components/undock/modules/contact'
import UpsellModule from '@components/undock/modules/upsell'

const ContactPage: NextPage = () => {
  return (
    <Page lightHeader>
      <Head>
        <title>Undock | Contact us</title>
        <script src="https://smtpjs.com/v3/smtp.js" />
      </Head>
      <ContactModule id="contact" themeName="light" type="upsellModule" />
      <UpsellModule
        ctaType="SIGN_UP"
        id="upsell"
        headline="Make time for what matters"
        themeName="dark"
        type="upsellModule"
      />
    </Page>
  )
}

export default ContactPage
